import React, { useState } from 'react'
import SignUpForm from './signupForm/Content'
import TopPosts from 'src/components/shared/modules/topPosts'
// import Opinions from 'src/components/pages/hub/opinion/Opinion'
import useStyles from './Styles'
// import WWYD from 'src/components/shared/modules/WWYD'
// import NotAlone from 'src/components/shared/modules/notAlone/NotAlone'
// import MeetNewFriend from 'src/components/shared/modules/meetNewFriends/MeetNewFriends'
// import ImpactCards from 'src/components/shared/modules/impactCards/Cards'
import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import { NeedASafeSpaceI } from 'src/types/store/index'

interface Props {
  zenMode: boolean
}

function SignUp({ zenMode }: Props) {
  const { classes } = useStyles()
  const { data } = useGetPageByNameQuery('signUp')

  const [topPostData, setTopPostData] = useState<NeedASafeSpaceI>()
  React.useEffect(() => {
    if (data && data.data.length > 0) {
      const content = data.data[0].attributes
      const { needASafeSpace } = content

      if (needASafeSpace) setTopPostData(needASafeSpace)
    }
  }, [data])

  return (
    <div>
      <SignUpForm />

      <div className={`${classes.topPostsWrapper} ${classes.zenBg}`}>
        {topPostData ? (
          <div className={classes.topPosts}>
            <TopPosts
              content={topPostData}
              zenMode={zenMode}
              community={true}
            />
          </div>
        ) : (
          ''
        )}

        <div className={classes.opinionsWrapper}></div>
      </div>
    </div>
  )
}

export default SignUp
